import { ImmutableStore } from 'fluxible-immutable-utils';
import Immutable, { Map } from 'immutable';
import Actions from '../constants/Actions';
import moment from 'moment';

const defaultState = Map({
  compliance: null,
  loading: false,
  error: null,
  focusedListItem: null,
  conversationLoading: false,
  conversation: null,
  conversationError: null,
  includeAll: false,
  excluded: []
});

function lastAllowed() {
  return moment().startOf('day');
}

class ComplianceDashboardStore extends ImmutableStore {

  static storeName = 'ComplianceDashboardStore';

  static handlers = {
    [Actions.COMPLIANCE__QUERY_STARTED]: 'setToLoading',
    [Actions.COMPLIANCE__QUERY_COMPLETED]: 'setCompliance',
    [Actions.COMPLIANCE__QUERY_FAILED]: 'setToError',
    [Actions.COMPLIANCE__LIST_ITEM_FOCUSED]: 'focusListItem',
    [Actions.COMPLIANCE__CONVERSATION_QUERY_STARTED]: 'setConversationToLoading',
    [Actions.COMPLIANCE__CONVERSATION_QUERY_COMPLETED]: 'setConversation',
    [Actions.COMPLIANCE__CONVERSATION_QUERY_FAILED]: 'setConversationToError',
    [Actions.COMPLIANCE__CONVERSATION_QUERY_CLEARED]: 'clearConversation',
    [Actions.PRODUCTS__EXCLUDED_PRODUCTS_TOGGLED]: 'setProductsExclude',
    [Actions.PRODUCTS__EXCLUDED_PRODUCTS_QUERY_STARTED]: 'queryExcluded',
    [Actions.PRODUCTS__EXCLUDED_PRODUCTS_QUERY_COMPLETED]: 'setExcluded',
    [Actions.PRODUCTS__EXCLUDED_PRODUCTS_QUERY_FAILED]: 'clearExcluded'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  static getAllowedDateRange() {
    return {
      start: lastAllowed().subtract(3, 'months').toDate(),
      end: lastAllowed().toDate()
    };
  }

  getCompliance() {
    return this.get('compliance');
  }

  isLoading() {
    return this.get('loading');
  }

  isIncludeAll() {
    return this.get('includeAll');
  }

  hasError() {
    return !!this.get('error');
  }

  getFocusedListItem() {
    return this.get('focusedListItem');
  }

  getConversation() {
    return this.get('conversation');
  }

  isConversationLoading() {
    return this.get('conversationLoading');
  }

  conversationHasError() {
    return !!this.get('conversationError');
  }

  setToLoading() {
    this.mergeState({
      compliance: null,
      loading: true,
      error: null
    });
  }

  setCompliance(compliance) {
    this.mergeState({
      compliance,
      loading: false,
      error: null
    });
  }

  setToError() {
    this.mergeState({
      compliance: null,
      loading: false,
      error: 'Failed to load compliance data'
    });
  }

  focusListItem(id) {
    const focused = this.getCompliance()
      .get('list')
      .find(li => li.get('_id') === id);
    this.mergeState({ focusedListItem: focused });
  }

  setConversationToLoading() {
    this.mergeState({
      conversation: null,
      conversationLoading: true,
      conversationError: null
    });
  }

  setConversation(conversation) {
    this.mergeState({
      conversation: Immutable.fromJS(conversation),
      conversationLoading: false,
      conversationError: null
    });
  }

  setConversationToError() {
    this.mergeState({
      conversation: null,
      conversationLoading: false,
      conversationError: 'Failed to load conversation'
    });
  }

  clearConversation() {
    this.mergeState({ conversation: null });
  }

  setProductsExclude(value) {
    this.mergeState({includeAll: !!value});
  }

  getExcluded() {
    return this.get('excluded');
  }

  queryExcluded() {
    this.mergeState({excluded: null});
  }

  setExcluded(excluded) {
    this.mergeState({excluded: excluded || []});
  }

  clearExcluded(ex) {
    console.error('Can`t read list of excluded products', ex);
    this.mergeState({excluded: []});
  }

}

export default ComplianceDashboardStore;



// WEBPACK FOOTER //
// ./src/stores/ComplianceDashboardStore.js